import type { QuoteBlock } from './QuoteTypes'

/**
 * QuoteDiscount — percent/value discounts per item and globally.
 */
export class QuoteDiscount {
  lineDiscountAmount(block: QuoteBlock): number {
    const gross = block.salePrice * block.quantity
    const byPercent = gross * (block.discountPercent / 100)
    return round2(Math.min(gross, byPercent + block.discountValue))
  }

  applyItemPercent(block: QuoteBlock, percent: number): QuoteBlock {
    return { ...block, discountPercent: Math.max(0, percent) }
  }

  applyItemValue(block: QuoteBlock, value: number): QuoteBlock {
    return { ...block, discountValue: Math.max(0, value) }
  }

  globalDiscountAmount(
    saleSubtotal: number,
    percent: number,
    value: number,
  ): number {
    const byPercent = saleSubtotal * (Math.max(0, percent) / 100)
    return round2(Math.min(saleSubtotal, byPercent + Math.max(0, value)))
  }
}

function round2(n: number): number {
  return Math.round((n + Number.EPSILON) * 100) / 100
}

export const quoteDiscount = new QuoteDiscount()
